import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26e19c28"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-news-wrapper"
};
const _hoisted_2 = {
  class: "home-news-content"
};
const _hoisted_3 = {
  class: "news-img"
};
const _hoisted_4 = ["name", "href"];
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = ["name", "href"];
const _hoisted_7 = {
  class: "news-info"
};
const _hoisted_8 = {
  class: "date"
};
const _hoisted_9 = {
  class: "view-and-like"
};
const _hoisted_10 = {
  class: "view-count"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-view"
}, null, -1));
const _hoisted_12 = {
  class: "like-count"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "t-icon t-icon-like"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_home_section = _resolveComponent("home-section");
  return _openBlock(), _createBlock(_component_home_section, {
    title: "行业资讯",
    class: "home-news"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.HOME_NEWS_OPTIONS, item => {
      var _ctx$state, _ctx$state2, _ctx$state3, _ctx$state4, _ctx$state5, _ctx$state6, _ctx$state7;
      return _openBlock(), _createElementBlock("div", {
        key: item.key + item.index,
        class: "home-news-item"
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
        name: item.imgTitle,
        href: _ctx.handleUrl(`news/detail/${(_ctx$state = _ctx.state) === null || _ctx$state === void 0 || (_ctx$state = _ctx$state[item.key]) === null || _ctx$state === void 0 || (_ctx$state = _ctx$state[item.index]) === null || _ctx$state === void 0 ? void 0 : _ctx$state.id}`),
        target: "_blank"
      }, [_createElementVNode("img", {
        src: item.img_url,
        alt: item.imgTitle
      }, null, 8, _hoisted_5)], 8, _hoisted_4)]), _createElementVNode("a", {
        name: (_ctx$state2 = _ctx.state) === null || _ctx$state2 === void 0 || (_ctx$state2 = _ctx$state2[item.key]) === null || _ctx$state2 === void 0 || (_ctx$state2 = _ctx$state2[item.index]) === null || _ctx$state2 === void 0 ? void 0 : _ctx$state2.title,
        class: "news-brief",
        href: _ctx.handleUrl(`news/detail/${(_ctx$state3 = _ctx.state) === null || _ctx$state3 === void 0 || (_ctx$state3 = _ctx$state3[item.key]) === null || _ctx$state3 === void 0 || (_ctx$state3 = _ctx$state3[item.index]) === null || _ctx$state3 === void 0 ? void 0 : _ctx$state3.id}`),
        target: "_blank"
      }, _toDisplayString((_ctx$state4 = _ctx.state) === null || _ctx$state4 === void 0 || (_ctx$state4 = _ctx$state4[item.key]) === null || _ctx$state4 === void 0 || (_ctx$state4 = _ctx$state4[item.index]) === null || _ctx$state4 === void 0 ? void 0 : _ctx$state4.title), 9, _hoisted_6), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString((_ctx$state5 = _ctx.state) === null || _ctx$state5 === void 0 || (_ctx$state5 = _ctx$state5[item.key]) === null || _ctx$state5 === void 0 || (_ctx$state5 = _ctx$state5[item.index]) === null || _ctx$state5 === void 0 || (_ctx$state5 = _ctx$state5.issue_at) === null || _ctx$state5 === void 0 || (_ctx$state5 = _ctx$state5.split(' ')) === null || _ctx$state5 === void 0 ? void 0 : _ctx$state5[0]), 1), _createElementVNode("span", _hoisted_9, [_createElementVNode("span", _hoisted_10, [_hoisted_11, _createTextVNode(_toDisplayString(((_ctx$state6 = _ctx.state) === null || _ctx$state6 === void 0 || (_ctx$state6 = _ctx$state6[item.key]) === null || _ctx$state6 === void 0 || (_ctx$state6 = _ctx$state6[item.index]) === null || _ctx$state6 === void 0 ? void 0 : _ctx$state6.view) || 0), 1)]), _createElementVNode("span", _hoisted_12, [_hoisted_13, _createTextVNode(_toDisplayString(((_ctx$state7 = _ctx.state) === null || _ctx$state7 === void 0 || (_ctx$state7 = _ctx$state7[item.key]) === null || _ctx$state7 === void 0 || (_ctx$state7 = _ctx$state7[item.index]) === null || _ctx$state7 === void 0 ? void 0 : _ctx$state7.like) || 0), 1)])])])]);
    }), 128))]), _createVNode(_component_router_link, {
      to: {
        path: '/news'
      },
      class: "btn-more"
    }, {
      default: _withCtx(() => [_createTextVNode("阅读更多")]),
      _: 1
    })])]),
    _: 1
  });
}